<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col>
        <base-material-card icon="mdi-account-group">
          <template v-slot:heading>
            <h3 class="display-2">Monitoring Review</h3>
          </template>
          <v-row>
            <v-col>
              <crud
              :crudSettings="crudSettings"
              :headers="headers"
              :responseData="{data:items}"
              :detailData="detailData"
              :forceUpdateTable="forceUpdate"
              @onTableChange="updateTable"
              >
              <template v-slot:prepend-header>
                <v-select style="max-width:200px" label="SKPD" hide-details class="mx-2"></v-select>
                <v-divider class="mx-2" inset vertical/>
                <v-select style="max-width:200px" :items="months" label="Bulan" hide-details class="mx-2"></v-select>
                <v-divider class="mx-2" inset vertical/>
              </template>
              <template v-slot:append-header>
                <v-spacer></v-spacer>
                <v-btn class="green mr-2" dark><v-icon>mdi-file-excel</v-icon> Export Excel</v-btn>
                <v-btn class="green" dark><v-icon>mdi-file-excel</v-icon> Export per SKPD</v-btn>
              </template>
            </crud>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {months} from '@/utils/lib'
import _ from 'lodash'
import Crud from '@/components/common/Crud'

export default {
  components:{
    Crud,
  },

  data(){
    return{
      forceUpdate:false,
      loading:false,
      detailData:{},

      headers:[
        {text:'No', value:'no', sortable:false, class:'header-index-profile'},
        {text:'Nip - Nama', value:'nama_peg', sortable:false, class:'header-index-profile'},
        {text:'Jabatan', value:'tgl', sortable:false, class:'header-index-profile'},
        {text:'Jumlah Review', value:'tgl', sortable:false, class:'header-index-profile'},
        {text:'Sudah Review', value:'sdh_review', sortable:false, class:'header-index-profile'},
        {text:'Jumlah Direview', value:'jml_direview', sortable:false, class:'header-index-profile'},
        {text:'Sudah Direview', value:'sdh_direview', sortable:false, class:'header-index-profile'},
        {text:'Status', value:'status', sortable:false, class:'header-index-profile'},
        {value:'aksi', sortable:false, class:'header-index-profile'},
      ],
      items:[],

      dialogReset:false,
      crudSettings:{
        title:'',
        detailTitle:'Detail',
        enableHeader:true,
        enableDetail:false,
        enableCreate:false,
      },
    }
  },

  watch:{},

  created(){
    let val = {itemsPerPage:10, page: 1}
    this.updateTable(val)
  },

  computed:{
    months(){
      return months
    }
  },

  methods:{
    getImg(nip,ext){
      if (nip){
        let avatarImgUrl = process.env.VUE_APP_IMG_URL + nip +"."+ext
        // this.avatarImages[nip] = avatarImgUrl
        return avatarImgUrl
      }
      return ''
    },

    updateTable(val){},
  },
}
</script>

<style lang="css" scoped>
</style>
